export const UI_DATA_SOURCE = 'UI';
